import { Shape } from '@mui/system';

const shape: Partial<Shape> = {
  borderRadius: 8,
  borderRadiusSm: 12,
  borderRadiusMd: 16,
};

export default shape;
